export const clearCompany = () => ({ type: "CLEAR_COMPANY" })
export const toggleMap = () => ({ type: "TOGGLE_MAP" })
export const fetchCompany = id => ({ type: "FETCH_COMPANY", payload: { id } })
export const fetchCompanyServices = id => ({
  type: "FETCH_COMPANY_SERVICES",
  payload: { id }
})
export const boundsChange = bounds => ({
  type: "BOUNDS_CHANGE",
  payload: bounds
})
export const zoomChange = zoom => ({ type: "ZOOM_CHANGE", payload: zoom })
export const clearBounds = () => ({ type: "CLEAR_BOUNDS" })
